import { Alert, Box, Button, Chip, Grid2, InputAdornment, Modal, TextField, Typography, Snackbar, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import SendIcon from '@mui/icons-material/Send';
import AddIcon from '@mui/icons-material/Add';
import { useForm } from 'react-hook-form';
import Switch from '@mui/material/Switch';
import axios from "axios";
import aubrey from './../assets/circleGif/aubrey.jpg'
import bharathi from './../assets/circleGif/bharathi.jpg'
import diana from './../assets/circleGif/dianaGifCircle.gif'
import gala from './../assets/circleGif/galaGifCircle.gif'
import geuilia from './../assets/circleGif/geuilia.jpg'
import natasha from './../assets/circleGif/natashaGifCircle.gif'
import boaticon from './../assets/images/chartbot-bg.jpg'
import intentsImage from './../assets/images/Chat-Agent-4.png'
import { AppBar, Toolbar, IconButton, Avatar, } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from "react-router-dom";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import allavatars from './../assets/images/groups12.jpg';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SettingsIcon from '@mui/icons-material/Settings';
import MovieCreationIcon from "@mui/icons-material/MovieCreation";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { JsonView, allExpanded, defaultStyles } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';
import { AudioRecorder } from 'react-audio-voice-recorder';
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Tooltip } from '@mui/material';
import sample_intents from '../../src/assets/sample_intents.xlsx'
import TopHeader from "./TopHeader";
import DownloadIcon from '@mui/icons-material/Download';
import SaveIcon from '@mui/icons-material/Save';
import TextRenderer from "./TextRender";
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',

    boxShadow: 24,
    p: 4,
};

const IntentsComponent = ({ id, type, pagename }) => {
    const label = { inputProps: { 'aria-label': 'Switch demo' } };
    const { register, handleSubmit, formState: { errors }, reset, trigger, setValue, clearErrors } = useForm({});
    const { handleSubmit: handleSubmit1, } = useForm({ mode: "all" });
    const { handleSubmit: handleSubmit2, } = useForm({ mode: "all" });
    const [editID, seteditID] = useState()
    const [chartInput, setChartInput] = useState()
    const [chartHistory, setchartHistory] = useState([])
    const [tagName, settagName] = useState()
    const [startForm, setstartForm] = useState(false)
    const [mutedFalse, setmutedFalse] = useState(false)
    const [codeCopytoClip, setcodeCopytoClip] = useState(false)
    const [apiurl, setapiurl] = useState()
    const [apitype, setapitype] = useState("GET")
    const [patterns, setpatterns] = useState()
    const [formMessage, setformMessage] = useState()
    const [response, setresponse] = useState()
    const [patternslist, setpatternslist] = useState([])
    const [showformsinlist, setshowformsinlist] = useState(false)
    const [modeltrainsuccess, setmodeltrainsuccess] = useState(false)
    const [modeltrainsuccess2, setmodeltrainsuccess2] = useState(false)
    const [showformsinlist2, setshowformsinlist2] = useState(false)
    const [videoplayModal, setvideoplayModal] = useState(false)
    const [VideoGeneration, setVideoGeneration] = useState(false)
    const [intentAddedSuccess, setintentAddedSuccess] = useState(false)
    const [listofchartboats, setlistofchartboats] = useState([])
    const [custompayloads, setcustompayloads] = useState([])
    const [formslist, setformslist] = useState([])
    const [avatarsurl, setavatarsurl] = useState('')
    const [errormsg, seterrormsg] = useState()
    const [selectAvatar, setselectAvatar] = useState("")
    const [avatarid, setavatarid] = useState()
    const [avatarids, setavatarids] = useState()
    const messagesEndRef = useRef(null);
    const [addProccess, setaddProccess] = useState(false)
    const [isDefault, setisDefault] = useState(false)
    const [loader, setloader] = useState(false);
    const [typingloader, settypingloader] = useState(false)
    const [generateVideos, setgenerateVideos] = useState(false);
    const [disableGenerateVideos, setdisableGenerateVideos] = useState();
    const AddCustomPayloads = () => {
        console.log('enrer')

        let custompayload = custompayloads

        setcustompayloads([...custompayload, { name: "" }])
    }
    const AddFormstonew = () => {
        let formslists = formslist
        setformslist([...formslists, {}])
    }

    const AddNewIntentstojson = () => {

        if (!addProccess) {
            setstartForm(true)
            let listofchats = listofchartboats
            setValue('video_path', "")
            listofchats.push({ name: "" })
            setlistofchartboats([...listofchats])
            setaddProccess(true)
            seteditID("")
            clearAllFields()
        } else {
            alert("You cannot add another form while one is already in progress.")
        }

    }
    const [videopath, setvideopaths] = useState()
    const onchangeIntentvaluesonclick = (data) => {
        clearErrors();
        setstartForm(true)
        settagName(data.name)
        setValue('tagName', data.name)
        if (data.data) {
            seteditID(data.id)
            setpatternslist(data.data.patterns)
            setshowformsinlist(data.data.form_status)
            setshowformsinlist2(data.data.api_call)
            setValue('video_path', data.data.video_path)
            setvideopaths(data.data.video_path)
            if (data.data.form_status) {
                setformMessage(data.data.form_message[0])
            }
            if (data.data.responses) {
                setValue('response', data.data.responses[0]);
                setresponse(data.data.responses[0])
            }

            if (data.data?.custom_payloads && data.data.id) {
                setcustompayloads(data.data.custom_payloads)
            }
            if (data.data.form_details && data.data.form_status) {
                setformslist(data.data.form_details)
            }
            if (data.data.api_call) {
                setapiurl(data.data.api_details.url)
                setapitype(data.data.api_details.method)
            }
        }
        setaddProccess(false)
        //setpatterns(objectid.patterns)
        setisDefault(data.is_default)
    }
    const ondeleteIntentValue = (data, i) => {
        if (window.confirm("Are you sure you want to delete this intent?")) {
            axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("Admintoken")}` }
            axios.delete(`apiV1/intents/${data.id}/`).then((rep) => {
                GetChartboatsList(id)
            }).catch((e) => {

            })
        } else {

        }
    }
    const [trainLoader, settrainLoader] = useState(false)
    const trainchartboattoModal = () => {
        settrainLoader(true)

        let req = {
            chatbot_id: id,
            bot_type: type
        }
        axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("Admintoken")}` }
        axios.post(`/apiV1/train-intents/`, req).then((rep) => {
            settrainLoader(false)
            setmodeltrainsuccess(true);
            setdisableGenerateVideos(false)
        }).catch((e) => {
            if (e.response.data.message && e.response.data.is_trained == false) {
                settrainLoader(false)
                setgenerateVideos(true)
            } else {
                settrainLoader(false)
                alert(e.response.data.message)
            }

        })
    }
    const sendInputFromCustomPayload = (data) => {
        settypingloader(true)
        let object = {
            isuser: true,
            text: data
        }

        let charts = chartHistory
        charts.push(object)
        setchartHistory([...charts])
        let charthistory21 = charthistory2
        charthistory21.push({ human: data })
        let req = {
            chatbot_id: id,
            avatar_name: avatarid,
            chat_history: charthistory21
        }

        setTimeout(() => {
            if (messagesEndRef.current) {
                messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
            }
        }, 1000);
        axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("Admintoken")}` }
        axios.post(`apiV1/chat-response/`, req).then((rep) => {
            if (rep.data.responses) {
                settypingloader(false)
                console.log(rep.data)
                let object = {
                    isuser: false,
                    text: rep.data
                }
                setChartInput("")
                let charts = chartHistory
                charts.push(object)
                setchartHistory([...charts])
                let object2 = {
                    ai: rep.data.responses[0]
                }
                let charthistory2s = charthistory2
                charthistory2s.push(object2)

                setcharthistory2([...charthistory2s])
                setTimeout(() => {
                    if (messagesEndRef.current) {
                        messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
                    }
                }, 1000);

            }

        }).catch((e) => {

            let object = {
                isuser: false,
                text: { responses: [e.response.data.message] }, // Show form_message if it exists

            };
            let charts = chartHistory
            charts.push(object)
            setchartHistory([...charts])
            settypingloader(false)
        })
    }
    const [charthistory2, setcharthistory2] = useState([]);
    const sendinputgetoutput = () => {
        settypingloader(true)
        setChartInput("")
        let object = {
            isuser: true,
            text: chartInput
        }
        let charts = chartHistory
        charts.push(object)
        setchartHistory([...charts])
        let charthistory21 = charthistory2
        charthistory21.push({ human: chartInput })
        let req = {
            chatbot_id: id,
            avatar_name: avatarid,
            //question: chartInput,
            chat_history: charthistory21
        }

        setTimeout(() => {
            if (messagesEndRef.current) {
                messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
            }
        }, 300);

        axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("Admintoken")}` }
        axios.post(`apiV1/chat-response/`, req).then((rep) => {
            if (rep.data.responses) {
                settypingloader(false)
                //console.log(rep.data.responses[0])
                let object = {
                    isuser: false,
                    text: rep.data
                }

                let charts = chartHistory
                charts.push(object)
                setchartHistory([...charts])

                let object2 = {
                    ai: rep.data.responses[0]
                }

                let charthistory2s = charthistory2

                charthistory2s.push(object2)

                setcharthistory2([...charthistory2s])

                setTimeout(() => {
                    setChartInput("")
                    if (messagesEndRef.current) {
                        messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
                    }
                }, 300);

            }

        }).catch((e) => {
            let object = {
                isuser: false,
                text: { responses: [e.response.data.message] }, // Show form_message if it exists

            };
            let charts = chartHistory
            charts.push(object)
            setchartHistory([...charts])
            settypingloader(false)
        })
    }
    const saveObjectToArrayList = (data) => {
        let pattern = []
        if (!patterns && patternslist.length == 0) {
            return false
        }


        if (patternslist.length == 0 && patterns) {
            pattern = patterns.split(',')
        } else {
            pattern = patternslist
        }


        let object = {
            name: data.tagName,
            chatbot: id,
            data: {
                patterns: pattern,
                responses: [data.response],
                custom_payloads: custompayloads,
                form_status: showformsinlist,
                api_call: showformsinlist2,
                form_details: formslist,
                form_message: [formMessage],
                api_details: {
                    url: apiurl,
                    method: apitype
                },
                video_path: videopath
            }
        }
        setdisableGenerateVideos(true)
        if (editID) {
            settrainLoader(true)
            axios.patch(`apiV1/intents/${editID}/`, object).then((rep) => {
                GetChartboatsList(id);
                setaddProccess(false)
                clearAllFields();
                reset();
                seteditID("")
                // setstartForm(false);
                setintentAddedSuccess(true)
                settrainLoader(false)
                //settypesofcharts(rep.data)

            }).catch((e) => {
                if (e.response.data.detail) {
                    seterrormsg(e.response.data.detail)
                }
                if (e.response.data.message) {
                    alert(e.response.data.message)
                }
                settrainLoader(false)
            })
        } else {
            settrainLoader(true)
            axios.post('apiV1/intents/', object).then((rep) => {
                GetChartboatsList(id);
                setaddProccess(false)
                generateVideoForChat('single', "add", rep.data.name)
                clearAllFields();
                reset();
                setstartForm(false);
                setintentAddedSuccess(true)
                settrainLoader(false)
                //settypesofcharts(rep.data)

            }).catch((e) => {
                settrainLoader(false)
                if (e.response.data.detail) {
                    seterrormsg(e.response.data.detail)
                }

                if (e.response.data.message) {
                    alert(e.response.data.message)
                }

            })
        }
    }
    const clearAllFields = () => {
        settagName("")
        setValue('tagName', "");
        setValue("response", "")
        setcustompayloads([])
        setformslist([])
        setpatterns("")
        setresponse("")
        setpatternslist([])
        setapitype("")
        setapiurl("")
        setshowformsinlist(false)
        setshowformsinlist2(false)
        seteditID("")
    }
    const changevaluesFromid = (value, i) => {
        let custompayload = custompayloads

        custompayload[i].name = value

        setcustompayloads([...custompayload])
    }
    const [payloadvalueshow, setpayloadvalueshow] = useState({})
    const changevaluesFromid2 = (value, i, type) => {
        let formslists = formslist
        formslists[i][type] = value;
        let objects = {}

        formslists.map((item, i) => {
            objects[item.label] = item.type
        })

        console.log(formslists)
        console.log(objects)
        setpayloadvalueshow(objects)
        setformslist([...formslists])
    }
    const handleClick = (i) => {
        let patternslists = patternslist
        patternslists.splice(i, 1);
        setpatternslist([...patternslists])
    }
    const addPatternstoList = () => {
        let patternslists = patternslist

        if (patterns) {

            let pattern = patterns.split(',')
            console.log(pattern)
            //patternslists.push(pattern);
            setpatternslist([...patternslists, ...pattern])
            setpatterns("")
        }

    }
    const [listofAvatars, setlistofAvatars] = useState([])
    const GetChartboatsList = (id) => {
        setloader(false)
        axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("Admintoken")}` }

        axios.get(`apiV1/intents/?chatbot_id=${id}`).then((rep) => {
            setloader(true)
            setlistofchartboats(rep.data)
        }).catch((e) => {
            setloader(true)
        })
    }
    const getavatarsList = (id) => {
        axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("Admintoken")}` }

        axios.get(`apiV1/list-avatars/?chatbot_id=${id}`).then((rep) => {
            if (rep.data) {
                if (rep.data.is_avatar_selected) {
                    setselectAvatar(true)
                    setavatarid(rep.data.avatar_name)
                }
            }
            setlistofAvatars(rep.data.avatars)
        }).catch((e) => {

        })

    }
    const audioConstraints = {
        audio: {
            sampleRate: 16000,  // Lower sample rate for speech
            channelCount: 1,    // Mono for smaller file sizes
            echoCancellation: false,
            noiseSuppression: false,
            autoGainControl: false
        }
    };
    const mediaStreamRef = useRef();
    const [mediaStream, setMediaStream] = useState(null);
    const [mediaRecorder, setMediaRecorder] = useState(null);
    let recordedChunks = [];
    const audioContextRef = useRef([]);
    const analyserRef = useRef([]);
    const dataArrayRef = useRef([]);
    const [isRecording, setIsRecording] = useState(false);
    var newMediaRecorder;

    const startRecording = async () => {
        setIsRecording(true)
        const mimeTypes = [
            'audio/webm',
            'audio/webm;codecs=opus',
            'audio/mp4',
            'audio/mpeg',
            'audio/ogg',
            'audio/wav',
        ];

        let supportedMimeType = null;

        for (const mimeType of mimeTypes) {
            if (MediaRecorder.isTypeSupported(mimeType)) {
                supportedMimeType = mimeType;
                break;
            }
        }

        if (supportedMimeType) {
            console.log(`Supported mimeType: ${supportedMimeType}`);
            // Proceed with MediaRecorder using the supported mimeType
        } else {
            console.error('No supported mimeType found.');
        }

        try {
            const stream = await navigator.mediaDevices.getUserMedia(audioConstraints);
            mediaStreamRef.current = stream; // Ensure the media stream is saved
            setMediaStream(stream);
            audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
            const mediaStreamSource = audioContextRef.current.createMediaStreamSource(mediaStreamRef.current);
            analyserRef.current = audioContextRef.current.createAnalyser();
            analyserRef.current.fftSize = 2048;
            mediaStreamSource.connect(analyserRef.current);
            dataArrayRef.current = new Float32Array(analyserRef.current.fftSize);

            newMediaRecorder = new MediaRecorder(stream, { supportedMimeType });
            setMediaRecorder(newMediaRecorder);

            newMediaRecorder.ondataavailable = (event) => {
                if (event.data.size > 0) {
                    recordedChunks.push(event.data);
                    //setRecordedChunks((prev) => [...prev, event.data]);
                }
            };

            newMediaRecorder.onstop = async () => {
                const blob = new Blob(recordedChunks, { type: supportedMimeType });
                recordedChunks = []  // Clear chunks for the next recording
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = async () => {
                    const base64Audio = reader.result.split(',')[1];  // Extract base64
                    const formData = new FormData();
                    formData.append('audio_file', base64Audio);
                    formData.append('file_extension', supportedMimeType === 'audio/mp4' ? 'mp4' : supportedMimeType === 'audio/webm' ? 'webm' : supportedMimeType === 'audio/ogg' ? 'ogg' : supportedMimeType === 'audio/mpeg' ? 'mpeg' : supportedMimeType === 'audio/wav' ? 'wav' : "mp4");
                    // API call
                    try {
                        const response = await fetch('https://speech.pranathiss.com/api/vad-base64-speech-to-text/', {
                            method: 'POST',
                            body: formData,
                        });
                        const result = await response.json();
                        sendInputFromCustomPayload(result.response)
                    } catch (error) {
                    }
                };
            }
            newMediaRecorder.start();

            //   setRecording(true);
        } catch (error) {
            console.error('Error accessing microphone:', error);
        }
    };
    const addAudioElement = async (blobs) => {
        settypingloader(true)
        const mimeTypes = [
            'audio/webm',
            'audio/webm;codecs=opus',
            'audio/mp4',
            'audio/mpeg',
            'audio/ogg',
            'audio/wav',
        ];

        let supportedMimeType = null;

        for (const mimeType of mimeTypes) {
            if (MediaRecorder.isTypeSupported(mimeType)) {
                supportedMimeType = mimeType;
                break;
            }
        }

        if (supportedMimeType) {
            console.log(`Supported mimeType: ${supportedMimeType}`);
            // Proceed with MediaRecorder using the supported mimeType
        } else {
            console.error('No supported mimeType found.');
        }


        const reader = new FileReader();
        reader.readAsDataURL(blobs);
        reader.onloadend = async () => {
            const base64Audio = reader.result.split(',')[1];  // Extract base64
            const formData = new FormData();
            formData.append('audio_file', base64Audio);
            formData.append('file_extension', supportedMimeType === 'audio/mp4' ? 'mp4' : supportedMimeType === 'audio/webm' ? 'webm' : supportedMimeType === 'audio/ogg' ? 'ogg' : supportedMimeType === 'audio/mpeg' ? 'mpeg' : supportedMimeType === 'audio/wav' ? 'wav' : "mp4");
            // API call
            try {
                const response = await fetch('https://speech.pranathiss.com/api/vad-base64-speech-to-text/', {
                    method: 'POST',
                    body: formData,
                });
                const result = await response.json();
                sendInputFromCustomPayload(result.response)
            } catch (error) {
            }
        };

    };
    const stopRecording = () => {
        setIsRecording(false);
        if (mediaRecorder) {
            mediaRecorder.stop();
            if (mediaStream) {
                mediaStream.getTracks().forEach((track) => track.stop());
            }
        }
        if (mediaStreamRef.current) {
            mediaStreamRef.current.getTracks().forEach(track => track.stop());
            mediaStreamRef.current = null;
        }
    };
    const handleremoveCustomPayload = (data, i) => {
        let custompayload = custompayloads
        custompayload.splice(i, 1);
        setcustompayloads([...custompayload])

    }

    const removeFormsFormList = (data, i) => {
        let formslists = formslist
        formslists.splice(i, 1);
        setformslist([...formslists])
    }

    const OnclickPreviewGetLink = async () => {
        settrainLoader(true)
        setgenerateVideos(false)
        axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("Admintoken")}` }
        axios.get(`apiV1/preview-chatbot/?chatbot_id=${id}&avatar_name=${avatarid}`).then((rep) => {
            settrainLoader(false)
            window.open(rep.data.page_url + '?preview=true', "_blank")
        }).catch((e) => {
            if (e.response.data.message && e.response.data.is_trained == false) {
                settrainLoader(false)
                setgenerateVideos(true)
            } else {
                settrainLoader(false)
                alert(e.response.data.message)
            }

        })

    }
    const tagnamechangereflectSide = (data) => {


        let listofchats = listofchartboats
        listofchats.map((item, i) => {
            if (listofchartboats.length - 1 == i) {
                item.name = data
            }
            return item
        })

        setlistofchartboats([...listofchats])
    }
    const cancelIntentAddingProcess = () => {
        GetChartboatsList(id)
        setaddProccess(false)
        clearAllFields();
        seteditID("");
        reset();

        setstartForm(false);
    }
    const checkVideoInView = (data) => {

    }
    const onchangeFormsToShowOrHide = (check) => {
        if (check) {
            setformslist([{}])
        } else {
            setformslist([])
        }

    }
    useEffect(() => {

        GetChartboatsList(id)
        getavatarsList(id)
    }, [])
    const handleAvatarToAPI = () => {
        let req = {
            "chatbot_id": id,
            "avatar_id": avatarids
        }
        axios.post('apiV1/update-avatar/', req).then((rep) => {
            // alert("videos generation is in progress!!")
        }).catch((e) => {

            if (e.response.data.detail) {
                seterrormsg(e.response.data.detail)
            }
            if (e.response.data.message) {
                alert(e.response.data.message)
            }

        })
    }
    const generateVideoForChat = (single, add, tagName) => {
        //settrainLoader(true)
        let req = {
            chatbot: id,
            avatar_name: avatarid,
            generate_all: single ? false : true,
        }

        if (single) {
            req.intent_name = tagName
        }
        axios.post('apiV1/generate-video/', req).then((rep) => {
            settrainLoader(false)
            if (!add) {

                setVideoGeneration(true)
            }
        }).catch((e) => {
            if (e.response.data.message && e.response.data.is_trained == false) {
                settrainLoader(true)
                setgenerateVideos(true)
            } else {
                alert(e.response.data.message)
                settrainLoader(false)
            }

            //setgenerateVideos(true)

        })
    }
    const [copiedIframe, setcopiedIframe] = useState("")
    const [openDialog, setOpenDialog] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);

    const copyIframeCode = () => {
        settrainLoader(true)
        axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("Admintoken")}` };
        axios.get(`apiV1/preview-chatbot/?chatbot_id=${id}&avatar_name=${avatarid}`)
            .then((rep) => {
                let totaliframe = `<style type="text/css"> 
                iframe{ width: 100%; height: 100%; border: 0; } .chatBoxImageClass{ position: fixed;  right: 15px;   bottom: 0px; } .chatBoxImageClass.active{  width: 790px; height: 670px; } .chatBoxImageClass.dnone{ display: none } .chartbotcloseicons{ position: absolute;  right: 42px; top: 45px; } .chatboticoninweb img{ width: 200px;   } @media (max-width: 768px) { .chatBoxImageClass.active{width: 100%; height: 100%;} .chartbotcloseicons{right: 5px; top:30px} .chatBoxImageClass{bottom: 0; right: 0;}} .positionclassin  {
            z-index: 999; background: #ededed; padding: 0px; font-size: 8px; position: absolute; bottom: 135px; right: 200px; box-shadow: 1px 0px 20px 0px #aaaaaa; width: 300px; border-radius: 10px;} .avatarimageHolder{ width: 200px; height: 271px; overflow: hidden; cursor: pointer; border-radius: 100%; max-height: 200px; position: absolute; bottom: 25px; right: 40px; } .closeicon{ color: red; cursor: pointer; background-color: #ededed;  border-radius: 100px;  position: absolute;  top: -10px; width: 30px;  height: 30px; right: -10px;  text-align: center; line-height: 30px; }
                </style><div class="chatBoxImageClass dnone" id="chatbotwithPotal">
        <div class="chartbotcloseicons" id="avatarcloseicon"  >
           <img src="https://chatagent.pranathiss.com/img/minimizeIcon/minimize1.png" alt="Line" />
        </div>
        <iframe id="myFrame" src=""   allow="camera; microphone; autoplay" sandbox="allow-same-origin allow-scripts allow-forms allow-modals allow-popups"></iframe>
   </div> 
    <div class="">
       <div class="chatBoxImageClass chatboticoninweb"  id="avatarimage">
                <div class="positionclassin">
                <h2>Hello! Let’s get started. What’s on your mind?</h2>  
                <div class="closeicon" id="oncloseicon"> ❌</div>
            </div>
            <div class='avatarimageHolder'>      
         <img src="https://d1duq3wrgv494c.cloudfront.net/static/${avatarid}/${avatarid}_static.gif" alt="" />
         </div>
       </div>
    </div>

    <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.7.1/jquery.min.js" integrity="sha512-v2CJ7UaYy4JwqLDIrZUI/4hqeoQieOmAZNXBeQyjo21dadnwR+8ZaIJVT8EE2iyI61OV8e6M8PP2/4hpQINQ/g==" crossorigin="anonymous" referrerpolicy="no-referrer"></script>
    
    <script>let url=${rep.data.page_url} $("#avatarimage").click(function(){ let iframe = $("#myFrame"); if (!iframe.attr("src")) { iframe.attr("src", url); }  $("#chatbotwithPotal").removeClass("dnone"); $("#chatbotwithPotal").addClass("active"); $('.chatboticoninweb').addClass("dnone"); }); $("#avatarcloseicon").click(function(){ $("#chatbotwithPotal").removeClass("active"); $("#chatbotwithPotal").addClass("dnone"); $(".chatboticoninweb").removeClass("dnone") }); $("#myFrame .speakerIconButton").hide();  $('#oncloseicon').click(function(){$('.positionclassin').hide()}) </script>`;
                //let reqs = `<iframe id="myFrame" src="${rep.data.page_url}" style="width: 100%; height: 100vh;" allow="camera; microphone" sandbox="allow-same-origin allow-scripts allow-forms allow-modals allow-popups"></iframe>`;
                setcopiedIframe(totaliframe);
                setOpenDialog(true);
            })
            .catch((e) => {

                if (e.response.data.message && e.response.data.is_trained == false) {
                    settrainLoader(false)
                    setgenerateVideos(true)
                } else {
                    settrainLoader(false)
                    alert(e.response.data.message)
                }

            });
    };

    const copyCustomText = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => setSnackbarOpen(true))
            .catch(err => console.error("Failed to copy:", err));
    };



    const [validationOpen, setValidationOpen] = useState(false);
    const [showValidation, setShowValidation] = useState(false);

    const handleFormsToggle = (checked) => {
        setshowformsinlist(checked);
        onchangeFormsToShowOrHide(checked);
        if (checked) {
            setShowValidation(false);
        } else {
            setshowformsinlist2(false);
            setShowValidation(false);
        }
    };

    const handleApiRequestsToggle = () => {
        if (!showformsinlist) {
            setShowValidation(true);
            return;
        }
        setshowformsinlist2(!showformsinlist2);
        setShowValidation(false);
    };

    const [selectedFile, setSelectedFile] = useState(null);
    const [open, setOpen] = useState(false);
    const fileInputRef = useRef(null);
    const [errorMessage, setErrorMessage] = useState("");

    const handleFileChange = (event) => {
        setErrorMessage("")
        if (event.target.files.length !== 0) {
            if (event.target.files[0]) {
                const allowedTypes = [
                    "text/csv",
                    "application/vnd.ms-excel",
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                ];

                if (!allowedTypes.includes(event.target.files[0].type)) {
                    setErrorMessage("Invalid file type. Only excel, CSV, XLS, and XLSX are allowed.");
                    fileInputRef.current.value = ""
                    return;
                }

                console.log("File is valid:");
            }
            if (event.target.files[0].size > 25 * 1024 * 1024) {
                setErrorMessage("Please select less 25MB file to scrap");
                fileInputRef.current.value = ""
                return false
            }

        }
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
            seterrormsg("");
        }
    };

    const handleUpload = async () => {

        if (!selectedFile) {
            setErrorMessage("Please select a file first.");
            return;
        }

        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("chatbot_name ", pagename);
        formData.append("chatbot_type ", type);

        try {
            await axios.post(
                "apiV1/intents/bulk-upload/",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            setmodeltrainsuccess2(true)
            handleClose();
            GetChartboatsList(id)

        } catch (error) {
            setErrorMessage(error.response?.data?.message || "File upload failed. Please try again.");
        }
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedFile(null);
        setErrorMessage("");
    };


    const handleDownloadSample = () => {
        const link = document.createElement("a");
        link.href = sample_intents;
        link.download = "sample_intents.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <>
            {trainLoader ? <div className="screenLoader">
                <div className='text-center' style={{ marginTop: "10%" }}>
                    <div className='spinner-grow text-primary' role='status'>
                        <span className='sr-only'>Loading...</span>
                    </div>
                </div>
            </div> : ""}

            <>
                <Grid2 size={{ xs: 12, md: 3, lg: 2 }}  >

                    <div className="card" style={{ margin: 0 }}>
                        <div className="card-body minheightforviwe2 mb-2" >
                            <div className="d-flex flex-row gap-2">
                                {type == "ADVANCED_WITH_KB" ? <Link to={`/chartbotintent?id=${id}&type=${type}&pagename=${pagename}`} sx={{ marginTop: 1 }}  > <ArrowBackIcon /></Link> : ""}
                                {type == "BASIC_WITHOUT_KB" ? <Link to={`/`} sx={{ marginTop: 1 }}  > <ArrowBackIcon /></Link> : ""}
                                <h5 className="mt-1 intentsTitleShow " > <b>{pagename}</b></h5>
                            </div>
                            <div className="d-flex align-items-center gap-1">
                                <button
                                    onClick={() => { AddNewIntentstojson(); seteditID(""); setisDefault(false) }}
                                    disabled={!(avatarid && selectAvatar)}
                                    className="position-relative d-inline-flex align-items-center justify-content-center greaditentbutton p-1 mb-2 me-2 overflow-hidden text-sm fw-medium text-dark rounded-lg border-0"
                                >
                                    <span
                                        className="position-relative px-4 py-2 rounded-md"
                                        style={{ transition: "0.3s" }}
                                    >
                                        + Intents
                                    </span>
                                </button>

                                <Tooltip title="Import Intents here" arrow
                                    PopperProps={{
                                        modifiers: [
                                            {
                                                name: "preventOverflow",
                                                options: {
                                                    boundary: "window",
                                                },
                                            },
                                        ],
                                    }}
                                    sx={{
                                        "& .MuiTooltip-tooltip": {
                                            fontSize: "2rem",
                                            padding: "10px",
                                            borderRadius: "8px",
                                        }
                                    }}
                                >
                                    <button
                                        className="d-flex align-items-center justify-content-center greaditentbutton p-1 mb-2 me-2 overflow-hidden text-sm fw-medium text-dark rounded-lg border-0"
                                        style={{ width: "55px", height: "45px" }} onClick={() => setOpen(true)}
                                    >
                                        <span className="cursor-pointer" >
                                            <CloudUploadIcon />
                                        </span>
                                    </button>
                                </Tooltip>
                            </div>




                            {/* <Button variant="contained" fullWidth size="large" onClick={() => { AddNewIntentstojson(); seteditID(""); setisDefault(false) }} disabled={avatarid && selectAvatar ? false : true} className={avatarid && selectAvatar ? "bluebuttoncustom" : "bluebuttoncustom disableavatar"}>+ Intents</Button> */}
                            <div className="file-manager-menu file-manager-menu2"  >
                                {loader ?
                                    <ul className="list-unstyled">
                                        {listofchartboats.map((intent, i) => {
                                            return (
                                                avatarid && selectAvatar ?
                                                    <li className={intent.id == editID ? "cursor-pointer   active" : "cursor-pointer   "} key={intent.id}>
                                                        <div onClick={() => onchangeIntentvaluesonclick(intent)} className="intentsTitleShow"><i className="far fa-folder"></i> {intent.name}</div>


                                                        {intent.is_default ? "" : intent.id ? <div onClick={() => ondeleteIntentValue(intent, i)} className="text-end textrightpo" >
                                                            <Button
                                                                sx={{ marginTop: "10px" }}
                                                                className="positionremoveButton"
                                                            >
                                                                <CloseIcon sx={{ color: "gray", "&:hover": { color: "red" } }} />
                                                            </Button>
                                                        </div> : ""}
                                                    </li> : <li className={intent.id == editID ? "cursor-pointer   active disableavatar" : "cursor-pointer  disableavatar"} key={intent.id}>
                                                        <div ><i className="far fa-folder"></i> {intent.name}</div>



                                                    </li>

                                            )
                                        })}
                                    </ul>
                                    :

                                    <div className='text-center' style={{ marginTop: "10%" }}>
                                        <div className='spinner-grow text-primary' role='status'>
                                            <span className='sr-only'>Loading...</span>
                                        </div>
                                    </div>}

                            </div>
                            <div className="positionabs">
                                <button style={{ background: avatarid && selectAvatar ? "linear-gradient(to right,#22c55e, #06b6d4)" : "#ccc" }} onClick={() => { trainchartboattoModal() }}
                                    className="position-relative d-inline-flex align-items-center justify-content-center greaditentbutton p-1  me-2 overflow-hidden text-sm fw-medium text-dark rounded-lg border-0" >
                                    <span className="position-relative px-4 py-2 rounded-md d-flex align-items-center" style={{ transition: "0.3s", gap: "8px" }} >
                                        <SettingsIcon style={{ fontSize: "1.5rem" }} /> TRAIN INTENTS
                                    </span>
                                </button>
                                <button onClick={() => { generateVideoForChat() }} disabled={disableGenerateVideos ? true : (avatarid && selectAvatar) ? false : true} title={disableGenerateVideos ? "Please train the intents before proceeding" : ""}
                                    className="position-relative d-inline-flex align-items-center justify-content-center p-1  me-2 greaditentbutton overflow-hidden text-sm fw-medium text-dark rounded-lg border-0" >
                                    <span className="position-relative px-4 py-2 rounded-md d-flex align-items-center" style={{ transition: "0.3s", gap: "8px" }} >
                                        <MovieCreationIcon style={{ fontSize: "1.5rem" }} /> GENERATE VIDEOS
                                    </span>
                                </button>
                            </div>

                        </div>
                    </div>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 9, lg: 10 }}  >
                    <TopHeader positionremove={true} />
                    <Grid2 container spacing={2} >
                        <Grid2 size={{ xs: 12, md: 6, lg: 8 }} sx={{ mt: 3 }} >
                            <div className="card minheightforviwe">
                                <div className="card-body">
                                    {startForm ?
                                        <Box
                                            component="form"
                                            sx={{ '& .MuiTextField-root': { m: 1, } }}
                                            id="mainForm"
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                if (e.target.id === 'form4') {
                                                    handleSubmit2(addPatternstoList)();
                                                } else {
                                                    handleSubmit(saveObjectToArrayList)();
                                                }
                                            }}
                                        >
                                            <div>

                                                <div className="mb-3 text-left">
                                                    <label htmlFor="outlined-tagName" className="form-label">Tag Name</label>
                                                    <input type="text" className="form-control" id="outlined-tagName" {...register("tagName", { required: "This field is required", })}
                                                        onKeyUp={() => {
                                                            trigger("tagName");
                                                        }}
                                                        placeholder="Tag Name"
                                                        onChange={(e) => tagnamechangereflectSide(e.target.value)}
                                                        disabled={isDefault}
                                                    />
                                                    {errors.tagName && (
                                                        <small className='text-danger font-bold'>
                                                            {errors.tagName.message}
                                                        </small>
                                                    )}
                                                </div>



                                                <div className="mb-3 text-left">
                                                    <label htmlFor="outlined-Patterns" className="form-label">Patterns</label>
                                                    <div className="input-group mb-3">
                                                        <input type="text" className="form-control" id="outlined-Patterns" value={patterns}
                                                            onChange={(e) => setpatterns(e.target.value)}
                                                            placeholder="Patterns"

                                                            disabled={tagName == "fallback" ? true : isDefault ? false : false}
                                                        />
                                                        <button className="input-group-text" onClick={(e) => {
                                                            e.preventDefault(); // Prevent triggering the parent form
                                                            handleSubmit2(addPatternstoList)();
                                                        }}
                                                            type="submit" id="basic-addon2" disabled={tagName == "fallback" ? true : isDefault ? false : false}>Add</button>
                                                    </div>

                                                    {!patterns && patternslist.length == 0 ?
                                                        <small className='text-danger font-bold'>
                                                            Please enter valid patterns
                                                        </small>
                                                        : ""}

                                                </div>
                                                <Box spacing={1} sx={{ marginBottom: "10px" }}>
                                                    {patternslist.map((patten, i) => {
                                                        return (

                                                            tagName == "fallback" ? <Chip key={"che" + i} label={patten} variant="outlined" sx={{ margin: "5px" }} /> : <Chip key={i} label={patten} variant="outlined" onDelete={() => handleClick(i)} sx={{ margin: "5px" }} />
                                                        )
                                                    })}
                                                </Box>
                                                <div className="mb-3 text-left">
                                                    <label htmlFor="outlined-response" className="form-label">Responses</label>
                                                    <input type="text" className="form-control" id="outlined-response" {...register("response", { required: "This field is required", })}
                                                        onKeyUp={() => {
                                                            trigger("response");
                                                        }}
                                                        placeholder="Responses"

                                                        disabled={tagName == "fallback" ? true : isDefault ? false : false}
                                                    />
                                                    {errors.response && (
                                                        <small className='text-danger font-bold'>
                                                            {errors.response.message}
                                                        </small>
                                                    )}
                                                </div>
                                                <div className="mb-3 text-left">
                                                    <label htmlFor="outlined-video_path" className="form-label">Video Url</label>
                                                    <div className="input-group mb-3">
                                                        <input type="text" className="form-control" id="outlined-video_path" readOnly {...register("video_path")} />
                                                        <button className="input-group-text" onClick={(e) => {
                                                            generateVideoForChat('single', "", tagName);
                                                        }}
                                                            type="button" id="basic-addon2" disabled={tagName == "fallback" ? true : isDefault ? false : false}>Generate</button>
                                                    </div>
                                                </div>
                                                {(tagName == "fallback") ? "" : <Typography variant="h6" component="h6" sx={{
                                                    mx: 1,

                                                    mt: 2,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between'
                                                }}>Custom Payload   <Button
                                                    variant="contained"
                                                    color="success"
                                                    sx={{ marginTop: "10px" }}
                                                    onClick={() => AddCustomPayloads()}
                                                >
                                                        <AddIcon />
                                                    </Button>  </Typography>}
                                                {custompayloads.map((item, i) => {
                                                    return (
                                                        <TextField

                                                            key={i}
                                                            id="outlined-required"
                                                            label="Payload"
                                                            inputProps={{
                                                                autoComplete: 'password',  // Ensure autoComplete is set to 'new-password' here
                                                            }}
                                                            value={item.name}
                                                            onChange={(e) => changevaluesFromid(e.target.value, i)}
                                                            defaultValue=""
                                                            InputProps={{ // <-- This is where the toggle button is added.
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            aria-label="toggle password visibility"
                                                                            onClick={() => handleremoveCustomPayload(item, i)}

                                                                            edge="end"
                                                                        >
                                                                            <CancelIcon />
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                )
                                                            }}
                                                        />
                                                    )
                                                })}

                                                <Box sx={{ border: "2px solid #3b82f6", borderRadius: "8px", padding: "16px", margin: "16px 0" }}>
                                                    {/* {!isDefault && ( */}
                                                    <Typography variant="h6" component="h6" sx={{ mx: 1, display: "flex", alignItems: "center", justifyContent: "space-between", }} >
                                                        Forms
                                                        <Switch checked={showformsinlist} onChange={(e) => handleFormsToggle(e.target.checked)} />
                                                    </Typography>
                                                    {/* )} */}

                                                    {showformsinlist ? (
                                                        <div className="mb-3 text-left">
                                                            <label htmlFor="outlined-ApiURL" className="form-label">Form Message</label>
                                                            <input type="text" className="form-control" id="outlined-ApiURL" placeholder="Form Message" value={formMessage} onChange={(e) => setformMessage(e.target.value)} />
                                                        </div>
                                                    ) : ""}

                                                    {formslist.map((items, i) => (
                                                        <Grid2 key={i}>
                                                            <Box sx={{ backgroundColor: "#f5f5f5", position: "relative", padding: "15px", marginBottom: "15px" }}>
                                                                <div className="mb-3 text-left">
                                                                    <label htmlFor="outlined-fallback" className="form-label">Label</label>
                                                                    <input type="text" className="form-control" id="outlined-fallback" placeholder="Label" value={items.label} onChange={(e) => changevaluesFromid2(e.target.value, i, "label")} />
                                                                </div>
                                                                <div className="mb-3 text-left">
                                                                    <label htmlFor="validationCustom04" className="form-label">Type</label>
                                                                    <select className="form-select" id="validationCustom04" value={items.type} onChange={(e) => changevaluesFromid2(e.target.value, i, "type")}>
                                                                        <option value="Charfield">Charfield</option>
                                                                        <option value="Integerfield">Integerfield</option>
                                                                        <option value="Emailfield">Emailfield</option>
                                                                    </select>
                                                                    <div className="invalid-feedback">
                                                                        Please select a valid state.
                                                                    </div>
                                                                </div>

                                                                <Button
                                                                    sx={{ marginTop: "10px" }}
                                                                    className="positionremoveButton"
                                                                    onClick={() => removeFormsFormList(items, i)}
                                                                >
                                                                    <CloseIcon sx={{ color: "gray", "&:hover": { color: "red" } }} />
                                                                </Button>


                                                            </Box>
                                                        </Grid2>
                                                    ))}

                                                    {showformsinlist ? (
                                                        <Box textAlign={"right"}>
                                                            <Button variant="contained" color="success" sx={{ marginTop: "10px" }} onClick={() => AddFormstonew()} >
                                                                <AddIcon />
                                                            </Button>
                                                        </Box>
                                                    ) : ""}
                                                </Box>
                                                <Box sx={{ border: "2px solid #3b82f6", borderRadius: "8px", padding: "16px", margin: "16px 0" }}>
                                                    {/* {!isDefault && ( */}
                                                    <>
                                                        <Typography variant="h6" component="h6" sx={{ mx: 1, display: "flex", alignItems: "center", justifyContent: "space-between", }} >
                                                            Api Requests
                                                            <Switch
                                                                checked={showformsinlist2}
                                                                onChange={(e) => {
                                                                    if (!showformsinlist) {
                                                                        setShowValidation(true);
                                                                        e.preventDefault();
                                                                        return;
                                                                    }
                                                                    setshowformsinlist2(e.target.checked);
                                                                    setShowValidation(false);
                                                                }}
                                                            />
                                                        </Typography>

                                                        {/* Validation Message */}
                                                        {showValidation && (
                                                            <Typography sx={{ color: "red", ml: 1, mt: 1, fontSize: "1rem" }}>
                                                                You need to enable "Forms" before activating this option.
                                                            </Typography>
                                                        )}

                                                    </>
                                                    {/* )} */}

                                                    {showformsinlist2 ?
                                                        <>
                                                            <div className="mb-3 text-left">
                                                                <label htmlFor="outlined-ApiURL" className="form-label">Api URL</label>
                                                                <input type="text" className="form-control" id="outlined-ApiURL"

                                                                    placeholder="Api URL"
                                                                    value={apiurl}
                                                                    onChange={(e) => setapiurl(e.target.value)}

                                                                />

                                                            </div>
                                                            <div className="mb-3 text-left">
                                                                <label htmlFor="setapitype" className="form-label">Type</label>
                                                                <select className="form-select" id="setapitype" value={apitype}
                                                                    onChange={(e) => setapitype(e.target.value)}>
                                                                    <option value="GET">GET</option>
                                                                    <option value="POST">POST</option>
                                                                    <option value="PUT">PUT</option>
                                                                    <option value="PATCH">PATCH</option>
                                                                    <option value="DELETE">DELETE</option>

                                                                </select>
                                                                <div className="invalid-feedback">
                                                                    Please select a valid state.
                                                                </div>
                                                            </div>

                                                            <div className="mb-3 text-left">
                                                                <label htmlFor="setapitype" className="form-label">Payload</label>
                                                                <JsonView data={payloadvalueshow} shouldExpandNode={allExpanded} style={defaultStyles} />
                                                                {/* <pre>
                                                            {JSON.stringify()}
                                                        </pre> */}
                                                            </div>




                                                        </> : ""}
                                                    {errormsg && <Alert severity="error" sx={{ mt: 2 }}>{errormsg}</Alert>}
                                                </Box>
                                            </div>
                                            <Box textAlign={"center"} sx={{ marginTop: "15px" }}>
                                                <button type="submit" style={{ height: "40px", width: "initial" }} className="position-relative d-inline-flex align-items-center justify-content-center p-1  me-2 overflow-hidden text-sm greaditentbutton fw-medium text-dark rounded-lg border-0" >
                                                    <span className="position-relative px-4 py-2  rounded-md" style={{ transition: "0.3s" }} > Save </span>
                                                </button>
                                                <button type="button" onClick={() => { cancelIntentAddingProcess() }} style={{ height: "40px", width: "initial", background: " linear-gradient(to right,rgb(233, 6, 6),rgb(240, 32, 49))" }}
                                                    className="position-relative d-inline-flex align-items-center justify-content-center p-1  me-2 overflow-hidden text-sm greaditentbutton fw-medium text-dark rounded-lg border-0" >
                                                    <span className="position-relative px-4 py-2  rounded-md" style={{ transition: "0.3s" }}  >
                                                        Cancel
                                                    </span>
                                                </button>
                                            </Box>

                                        </Box>
                                        :
                                        <Box textAlign={"center"}>
                                            <img src={intentsImage} style={{ maxWidth: "100%", margin: "10% auto" }} alt="Chat Portal" />
                                        </Box>
                                    }
                                </div>
                            </div>

                        </Grid2>
                        <Grid2 size={{ xs: 12, md: 6, lg: 4 }} sx={{ mt: 4 }}>
                            {selectAvatar ?
                                <div className="card">
                                    <div className=" ">

                                        <AppBar position="static" style={{ background: 'linear-gradient(to right, #3f51b5, #2196f3)', borderRadius: "10px 10px 0px 0px" }}>
                                            <Toolbar sx={{ paddingRight: 2 }}>
                                                <IconButton edge="start" color="inherit" aria-label="back" sx={{ padding: 0 }} onClick={() => { setselectAvatar(""); setavatarid(""); setstartForm("") }}>
                                                    <ArrowBackIosIcon />
                                                </IconButton>
                                                <Avatar alt={avatarid} src={`https://d1duq3wrgv494c.cloudfront.net/static/${avatarid}/${avatarid}_static.jpg`} style={{ marginRight: 8 }} />
                                                <Typography variant="h6" style={{ flex: 1 }}>
                                                    Hi There!
                                                </Typography>
                                                <Box display="flex" alignItems="center" onClick={() => { setselectAvatar(""); setavatarid("") }}>
                                                    <Typography variant="h6" style={{ marginRight: 5, cursor: "pointer" }} >
                                                        Change
                                                    </Typography>
                                                    <Avatar alt="Change Avatar" src={allavatars} style={{ marginRight: 8, cursor: "pointer" }} />
                                                </Box>
                                            </Toolbar>
                                        </AppBar>
                                        <div className="chat-container bg-white">
                                            <div className="d-flex flex-column mb-3 min-heightwithscroll">
                                                {chartHistory.map((chart, i) => {
                                                    return chart.isuser ? <div className="chat-bubble user">
                                                        {chart.text}
                                                    </div> : <>
                                                        <div className="chat-bubble bot">

                                                            <TextRenderer text={chart.text.responses[0]} />
                                                            {/* {chart.text.responses[0]} */}
                                                        </div>
                                                        <ul className="custompayloads">
                                                            {chart.text.custom_payloads && chart.text.custom_payloads.map((pattern, i) => {
                                                                return (
                                                                    <li key={"char" + i} onClick={() => sendInputFromCustomPayload(pattern.name)} className="onhoverpointer">{pattern.name}</li>
                                                                )
                                                            })}
                                                        </ul>
                                                    </>
                                                })}
                                                {typingloader ?
                                                    <div class="typing d-flex align-items-center">
                                                        <div class="spinner-grow text-dark mx-1" style={{ width: " 8px", height: "8px" }}></div>
                                                        <div class="spinner-grow text-dark mx-1" style={{ width: " 8px", height: "8px" }}></div>
                                                        <div class="spinner-grow text-dark mx-1" style={{ width: " 8px", height: "8px" }}></div>
                                                    </div> : ""}
                                                <div ref={messagesEndRef} />
                                            </div>
                                            <Box sx={{ backgroundColor: "#fff" }} component="form" id="form2" onSubmit={handleSubmit1(sendinputgetoutput)} >
                                                <Box sx={{ display: "flex", alignItems: "center", width: "100%", maxWidth: 500, borderRadius: "8px", padding: "14px", }} >
                                                    <TextField fullWidth variant="outlined" placeholder="Try it now" value={chartInput} onChange={(e) => setChartInput(e.target.value)} InputProps={{ sx: { border: "none", outline: "none" }, }} />
                                                    <IconButton type="submit" className="iconsbuttonbk">
                                                        <SendIcon />
                                                    </IconButton>
                                                    <AudioRecorder onRecordingComplete={addAudioElement} />
                                                    {/* {isRecording ? <IconButton onClick={() => stopRecording()}>
                                                    <MicOffIcon />
                                                </IconButton> :
                                                 <IconButton onClick={() => startRecording()}>
                                                <MicIcon />
                                            </IconButton> }
                                            */}
                                                    {/* <IconButton type="button" onClick={()=> ()} >
                                                <ContentCopyIcon />
                                            </IconButton> */}
                                                </Box>
                                                <Box sx={{ margin: "0px 15px", }}>
                                                    <button type="button" onClick={() => OnclickPreviewGetLink()} style={{ height: "40px" }}
                                                        className="position-relative d-inline-flex align-items-center justify-content-center p-1  me-2 overflow-hidden text-sm greaditentbutton fw-medium text-dark rounded-lg border-0" >
                                                        <span className="position-relative px-4 py-2 rounded-md d-flex align-items-center" style={{ transition: "0.3s", gap: "8px" }} >
                                                            <VisibilityIcon style={{ fontSize: "1.5rem" }} /> PREVIEW
                                                        </span>
                                                    </button>
                                                </Box>

                                                <Box sx={{ margin: "0px 15px", paddingBottom: "10px" }}>
                                                    <button type="button" onClick={() => copyIframeCode()} style={{ height: "40px" }}
                                                        className="position-relative d-inline-flex align-items-center justify-content-center p-1  me-2 overflow-hidden text-sm fw-medium text-dark rounded-lg border-0 greaditentbutton" >
                                                        <span className="position-relative px-4 py-2 rounded-md d-flex align-items-center" style={{ transition: "0.3s", gap: "8px" }} >
                                                            <ContentCopyIcon style={{ fontSize: "1.5rem" }} /> COPY IFRAME CODE
                                                        </span>
                                                    </button>
                                                    <Dialog open={openDialog} onClose={() => { setOpenDialog(false); settrainLoader(false) }} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                                                        PaperProps={{ sx: { borderRadius: "5px", maxHeight: "400px" } }}>
                                                        <DialogTitle sx={{ fontWeight: "bold", }}>
                                                            Copy the iframe code below!
                                                            <CloseIcon sx={{ float: "right", cursor: "pointer" }} onClick={() => { setOpenDialog(false); settrainLoader(false) }} />
                                                        </DialogTitle>
                                                        <DialogContent>
                                                            <Box sx={{ padding: "10px", borderRadius: "5px", wordBreak: "break-all", border: "1px solid #ccc", fontFamily: "monospace", }}>
                                                                {copiedIframe}
                                                            </Box>
                                                        </DialogContent>
                                                        <DialogActions sx={{ padding: '20px' }}>
                                                            <Button onClick={() => { copyCustomText(copiedIframe); setOpenDialog(false); settrainLoader(false) }} color="primary" variant="contained" sx={{ display: "flex", alignItems: "center", gap: "2px", padding: "10px 16px", fontSize: "0.95rem", fontWeight: "bold", borderRadius: "8px", }} >
                                                                <ContentCopyIcon fontSize="small" /> Copy
                                                            </Button>
                                                        </DialogActions>
                                                    </Dialog>

                                                    <Snackbar open={snackbarOpen} autoHideDuration={2000} onClose={() => setSnackbarOpen(false)} anchorOrigin={{ vertical: "center", horizontal: "center" }} >
                                                        <Alert onClose={() => setSnackbarOpen(false)} severity="info" className="AlertSuccessMUI" >
                                                            📋 Copied to clipboard!
                                                        </Alert>
                                                    </Snackbar>
                                                </Box>
                                            </Box>
                                        </div>
                                    </div>
                                </div> : ""}
                            {!selectAvatar ?
                                <div className="card">
                                    <div className="">
                                        <ul className="avatarimage">
                                            {listofAvatars.map((avatars, h) => {
                                                return (
                                                    <li key={"video" + h} onClick={() => { setavatarid(avatars.avatar_name); setavatarids(avatars.id); }} className={avatarid == avatars.avatar_name ? "active" : ""}>
                                                        <video src={avatars.url} className="avatarVideoTag"></video>
                                                        <button className="videopreviewclass" onClick={() => { checkVideoInView(avatars); setavatarsurl(avatars.url); setvideoplayModal(true); setmutedFalse(true) }}>Preview</button>
                                                        <div className="avatarNameShow">
                                                            {avatars.avatar_name}
                                                        </div>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                        <Box sx={{ margin: "15px", paddingBottom: "15px" }}>
                                            <button disabled={avatarid ? false : true} onClick={() => { avatarid ? setselectAvatar(true) : alert("Please select your avatar"); handleAvatarToAPI(); }}
                                                className="position-relative d-inline-flex align-items-center greaditentbutton justify-content-center p-1  me-2 overflow-hidden text-sm fw-medium text-dark rounded-lg border-0" >
                                                <span className="position-relative px-4 py-2  rounded-md" style={{ transition: "0.3s" }} >
                                                    Select Avatar
                                                </span>
                                            </button>
                                        </Box>
                                    </div>
                                </div> : ""}
                        </Grid2>
                    </Grid2>
                </Grid2>

                <Snackbar open={modeltrainsuccess} autoHideDuration={6000} onClose={() => setmodeltrainsuccess(false)} anchorOrigin={{ vertical: "bottom", horizontal: "center" }} >
                    <Alert onClose={() => setmodeltrainsuccess(false)} severity="success" className="AlertSuccessMUI" >
                        Your chatbot has trained successfully!
                    </Alert>
                </Snackbar>

                <Snackbar open={modeltrainsuccess2} autoHideDuration={6000} onClose={() => setmodeltrainsuccess2(false)} anchorOrigin={{ vertical: "bottom", horizontal: "center" }} >
                    <Alert onClose={() => setmodeltrainsuccess2(false)} severity="success" className="AlertSuccessMUI" >
                        Your intents uploaded successfully!
                    </Alert>
                </Snackbar>

                <Snackbar open={intentAddedSuccess} autoHideDuration={6000} onClose={() => setintentAddedSuccess(false)} anchorOrigin={{ vertical: "bottom", horizontal: "center" }} >
                    <Alert onClose={() => setintentAddedSuccess(false)} severity="success" className="AlertSuccessMUI" >
                        Your chat intent was saved successfully!
                    </Alert>
                </Snackbar>
                <Modal open={videoplayModal} onClose={() => setvideoplayModal(false)} aria-labelledby="parent-modal-title" aria-describedby="parent-modal-description" >
                    <Box sx={{ ...style, width: 500 }}>
                        <IconButton aria-label="close" onClick={() => setvideoplayModal(false)} sx={{ position: 'absolute', top: 8, right: 8 }} >
                            <CloseIcon />
                        </IconButton>
                        <Grid2 container spacing={2} textAlign={"center"}>
                            <Grid2 size={12}>
                                <video src={avatarsurl} width={"100%"} autoPlay muted={!mutedFalse} loop style={{ padding: "10px" }}></video>
                            </Grid2>
                        </Grid2>

                        <Grid2 container spacing={2} textAlign={"center"}>
                            <Grid2 size={12} sx={{ mt: 4 }} textAlign={"center"}>
                                <Button variant="contained" sx={{ mx: 2 }} onClick={() => setvideoplayModal(false)}>Ok</Button>

                            </Grid2>
                        </Grid2>
                    </Box>
                </Modal>
                <Modal open={VideoGeneration} onClose={() => setVideoGeneration(false)} aria-labelledby="parent-modal-title" aria-describedby="parent-modal-description" >
                    <Box sx={{ ...style, width: 450, borderRadius: "8px" }}>
                        <Grid2 container spacing={2} textAlign={"center"}>
                            <Grid2 size={12}>
                                Video generation has been added to the queue. once its done you will be notified via email.
                            </Grid2>
                        </Grid2>

                        <Grid2 container spacing={2} textAlign={"center"}>
                            <Grid2 size={12} sx={{ mt: 4 }} textAlign={"center"}>
                                <Button sx={{ mx: 2, backgroundColor: "#3e68cf", color: "white", }} onClick={() => setVideoGeneration(false)}>Ok</Button>
                            </Grid2>
                        </Grid2>
                    </Box>
                </Modal>

                <Modal open={codeCopytoClip} onClose={() => { setcodeCopytoClip(false); settrainLoader(false) }} aria-labelledby="parent-modal-title" aria-describedby="parent-modal-description" >
                    <Box sx={{ ...style, width: 500 }}>
                        <Grid2 container spacing={2} textAlign={"center"}>
                            <Grid2 size={12}>
                                <textarea className="form-control" rows={8}>{copiedIframe}</textarea>
                            </Grid2>
                            <Grid2 size={12}>
                                <h4>Your iframe code copied to clipboard</h4>
                            </Grid2>
                        </Grid2>

                        <Grid2 container spacing={2} textAlign={"center"}>
                            <Grid2 size={12} sx={{ mt: 4 }} textAlign={"center"}>
                                <Button variant="contained" sx={{ mx: 2 }} onClick={() => { setcodeCopytoClip(false); settrainLoader(false) }}>Ok</Button>

                            </Grid2>
                        </Grid2>
                    </Box>
                </Modal>
                <Modal open={open} onClose={() => setOpen(false)}>
                    <Box className="modal-box" sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: 450, bgcolor: "background.paper", boxShadow: 24, p: 3, borderRadius: 2, }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Typography variant="h6" fontWeight="bold">Import Intents</Typography>
                            <CloseIcon sx={{ cursor: "pointer" }} onClick={handleClose} />
                        </Box>
                        <Box sx={{ border: "2px dashed #ccc", borderRadius: 2, textAlign: "center", p: 3, mt: 2, cursor: "pointer" }} onClick={() => fileInputRef.current.click()} >
                            <CloudUploadIcon fontSize="large" color="disabled" />
                            <Typography variant="body2">
                                <span style={{ color: "#007bff", cursor: "pointer" }}>Choose file</span> to upload
                            </Typography>
                            <Typography variant="caption" color="textSecondary">
                                Eg: (excel, csv)
                            </Typography>
                            <input type="file" style={{ display: "none" }} accept=".xlsx,.xls, .csv" ref={fileInputRef} onChange={handleFileChange} />
                            {selectedFile && (
                                <Typography variant="body2" sx={{ mt: 1, textAlign: "center", color: "#555" }}>
                                    Selected File: {selectedFile.name}
                                </Typography>
                            )}
                        </Box>
                        {errorMessage && (
                            <Typography variant="body2" sx={{ mt: 1, textAlign: "center", color: "red" }}>
                                {errorMessage}
                            </Typography>
                        )}

                        <Box display="flex" justifyContent="space-between" alignItems="center" width="100%" sx={{ padding: "0px 0px", mt: 3 }}>
                            <Button onClick={handleDownloadSample} variant="contained" color="secondary"
                                sx={{ display: "flex", alignItems: "left", justifyContent: "left", fontSize: "1rem", color: "white", border: "none", background: "linear-gradient(90deg, #00C853, #00B8D4)", textTransform: "uppercase", "&:hover": { background: "linear-gradient(90deg, #00B8D4, #00C853)", }, }} >
                                <DownloadIcon /> Download Sample
                            </Button>
                            <Button onClick={handleUpload} variant="contained" color="primary" disabled={!selectedFile}  >
                                <SaveIcon />  &nbsp;Save
                            </Button>
                        </Box>
                    </Box>
                </Modal>
                <Modal open={generateVideos} onClose={() => setgenerateVideos(false)} aria-labelledby="parent-modal-title" aria-describedby="parent-modal-description" >
                    <Box sx={{ ...style, width: 500 }}>
                        <Grid2 container spacing={2} textAlign={"center"}>

                            <Grid2 size={12}>
                                <h4>Your chatbot not trained..! <br /> <sapn style={{ fontSize: "20px" }}>please train your bot then you can preview</sapn></h4>
                            </Grid2>
                        </Grid2>

                        <Grid2 container spacing={2} textAlign={"center"}>
                            <Grid2 size={12} sx={{ mt: 2 }} textAlign={"center"}>
                                <button type="submit" onClick={() => { trainchartboattoModal(); setgenerateVideos(false) }} style={{ height: "40px", width: "initial" }}
                                    className="position-relative d-inline-flex align-items-center justify-content-center p-1  me-2 overflow-hidden text-sm greaditentbutton fw-medium text-dark rounded-lg border-0" >
                                    <span className="position-relative px-4 py-2  rounded-md" style={{ transition: "0.3s" }} >
                                        Train Chatbot
                                    </span>
                                </button>
                                <button type="button" onClick={() => { setgenerateVideos(false); settrainLoader(false) }} style={{ height: "40px", width: "initial", background: " linear-gradient(to right,rgb(233, 6, 6),rgb(240, 32, 49))" }}
                                    className="position-relative d-inline-flex align-items-center justify-content-center p-1  me-2 overflow-hidden text-sm greaditentbutton fw-medium text-dark rounded-lg border-0"  >
                                    <span className="position-relative px-4 py-2  rounded-md" style={{ transition: "0.3s" }}  >
                                        Cancel
                                    </span>
                                </button>

                            </Grid2>
                        </Grid2>
                    </Box>
                </Modal>
            </>
        </>
    )
}

export default IntentsComponent